import { TabsList, TabsTrigger } from './tabs';

interface DetailTabListProps {
  tabs: Array<{ value: string; label: string }>;
}

const TRIGGER_CLASS =
  'rounded-none border-b-2 border-transparent data-[state=active]:border-[#242424] data-[state=active]:bg-transparent whitespace-nowrap text-[#242424]';

export function DetailTabList({ tabs }: DetailTabListProps) {
  return (
    <TabsList className="w-full justify-start overflow-x-auto flex-nowrap h-auto p-0 bg-transparent border-b border-border rounded-none">
      {tabs.map((tab) => (
        <TabsTrigger key={tab.value} value={tab.value} className={TRIGGER_CLASS}>
          {tab.label}
        </TabsTrigger>
      ))}
    </TabsList>
  );
}
